<template>
  <div>
    <b-card
      no-body
      class="my-1"
      :class="{ 'card-transparent-background': type == 'register' }"
    >
      <b-card-header
        class=""
        :class="{
          'card-header-profile-border': type == 'profile' || type == 'edit',
          'card-header-form-doorder': type == 'register',
        }"
        ><h4>Shopify Details</h4></b-card-header
      >

      <b-card-body
        class=""
        :class="{
          'p-2': type == 'profile' || type == 'edit',
          'py-0': type == 'register',
        }"
      >
        <div class="container">
          <b-row>
            <b-col sm="6">
              <b-form-group
                label="Shop URL"
                label-for="shopify_store_domain"
                :shopify_store_domain="shopify_store_domain"
                label-class="form-label-doorder"
              >
                <b-form-input
                  v-if="type == 'register' || type == 'edit'"
                  id="shopify_store_domain"
                  class="form-control-doorder"
                  v-model="_shopify_store_domain"
                  :shopify_store_domain="shopify_store_domain"
                  placeholder="Shop URL"
                ></b-form-input>
                <span
                  v-if="type == 'profile'"
                  class="form-control form-control-doorder"
                >
                  {{ _shopify_store_domain }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="App API key"
                label-for="shopify_app_api_key"
                :shopify_app_api_key="shopify_app_api_key"
                label-class="form-label-doorder"
              >
                <b-form-input
                  v-if="type == 'register' || type == 'edit'"
                  id="shopify_app_api_key"
                  class="form-control-doorder"
                  v-model="_shopify_app_api_key"
                  :shopify_app_api_key="shopify_app_api_key"
                  placeholder="App API key"
                ></b-form-input>
                <span
                  v-if="type == 'profile'"
                  class="form-control form-control-doorder"
                >
                  {{ _shopify_app_api_key }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="App password"
                label-for="shopify_app_password"
                :shopify_app_password="shopify_app_password"
                label-class="form-label-doorder"
              >
                <b-form-input
                  v-if="type == 'register' || type == 'edit'"
                  id="shopify_app_password"
                  class="form-control-doorder"
                  v-model="_shopify_app_password"
                  :shopify_app_password="shopify_app_password"
                  placeholder="App password"
                ></b-form-input>
                <span
                  v-if="type == 'profile'"
                  class="form-control form-control-doorder"
                >
                  {{ shopify_app_password }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="App secret"
                label-for="shopify_app_secret"
                :shopify_app_secret="shopify_app_secret"
                label-class="form-label-doorder"
              >
                <b-form-input
                  v-if="type == 'register' || type == 'edit'"
                  id="shopify_app_secret"
                  class="form-control-doorder"
                  type="number"
                  min="1"
                  v-model="_shopify_app_secret"
                  :shopify_app_secret="shopify_app_secret"
                  placeholder="App secret"
                ></b-form-input>
                <span
                  v-if="type == 'profile'"
                  class="form-control form-control-doorder"
                >
                  {{ shopify_app_secret }}
                </span>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "ShopifyDetails",
  props: [
    "type",
    "status",
    "shopify_store_domain",
    "shopify_app_api_key",
    "shopify_app_password",
    "shopify_app_secret",
  ],
  data() {
    return {};
  },
  computed: {
    _shopify_store_domain: {
      get() {
        return this.shopify_store_domain;
      },
      set(value) {
        this.$emit("update:shopify_store_domain", value);
      },
    },
    _shopify_app_api_key: {
      get() {
        return this.shopify_app_api_key;
      },
      set(value) {
        this.$emit("update:shopify_app_api_key", value);
      },
    },
    _shopify_app_password: {
      get() {
        return this.shopify_app_password;
      },
      set(value) {
        this.$emit("update:shopify_app_password", value);
      },
    },
    _shopify_app_secret: {
      get() {
        return this.shopify_app_secret;
      },
      set(value) {
        this.$emit("update:shopify_app_secret", value);
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doorder/retailers/profile_details_components/ShopifyDetails.vue